<template>
  <div class="min-h-screen flex flex-col justify-between overflow-auto">
    <MenuNavbar />
    
    <div v-if="$route.name !== 'HomeMenuView'"
      class="flex flex-row items-center m-4 rounded-full w-fit cursor-pointer hover:scale-105 transition-all"
      @click="$router.go(-1)">
      <img src="../assets/return-button.svg" class="h-14 w-14" />
    </div>

    <router-view class="h-full grow"></router-view>
    <FooterComponent />
  </div>
</template>

<script>
import MenuNavbar from '@/components/ui/MenuNavbar.vue'
import FooterComponent from '@/components/ui/FooterComponent.vue'

export default {
  name: 'MobileLayoutView',
  components: { MenuNavbar, FooterComponent },
  mounted() {
    // Fallback: re-emit auth-complete after navigation to help slower environments
    try {
      if (localStorage.getItem('token')) {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('cognito-auth-complete'))
        }, 200)
      }
    } catch (e) {
      // silent
    }
  }
}
</script>
